"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _DepositTemplateFormComponent = _interopRequireDefault(require("./DepositTemplateFormComponent"));
var _DepositWorkflowsContainer = _interopRequireDefault(require("./DepositWorkflows/DepositWorkflowsContainer"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _config = _interopRequireDefault(require("../../config"));
var _APSelect = _interopRequireDefault(require("../common/APSelect"));
require("./DepositFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('deposit-form');
var slidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('slide-pane');
var DepositFormComponent = /*#__PURE__*/function (_React$Component) {
  function DepositFormComponent() {
    _classCallCheck(this, DepositFormComponent);
    return _callSuper(this, DepositFormComponent, arguments);
  }
  _inherits(DepositFormComponent, _React$Component);
  return _createClass(DepositFormComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        selectDepositProduct = _this$props.selectDepositProduct,
        product = _this$props.product;
      selectDepositProduct(product.ProductId);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        handleSubmit = _this$props2.handleSubmit,
        submitting = _this$props2.submitting,
        deposit = _this$props2.deposit,
        product = _this$props2.product,
        changeFieldValue = _this$props2.changeFieldValue,
        selectDepositTemplate = _this$props2.selectDepositTemplate,
        isDasc = _this$props2.isDasc;
      var showTemplateTypeSelect = deposit.templateTypes.length > 1 && !Object.keys(deposit.templateInfo).length && !deposit.isLoading;
      var templateTypes = [{
        value: '',
        label: 'Select an option'
      }].concat(_toConsumableArray(deposit.templateTypes.map(function (template) {
        return {
          value: template.AccountProviderId,
          label: template[_config["default"].Deposit.AccountProviderDisplayKey]
        };
      })));
      var useTemplateDepositWorkflow = deposit.depositInfo && !!deposit.depositInfo.length;
      if (deposit.depositInfo.length && isDasc) {
        var dataArr = deposit.depositInfo[0].split('?dt=');
        deposit.template = {
          exchangeAddress: dataArr[0],
          memo: dataArr[1]
        };
        setTimeout(function () {
          //update data outside render
          changeFieldValue('exchangeAddress', deposit.template.exchangeAddress);
          changeFieldValue('memo', deposit.template.memo);
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DepositWorkflowsContainer["default"], {
        submitting: submitting,
        onSubmit: handleSubmit
      }), deposit.isLoading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        customClass: baseClasses
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, deposit.error && /*#__PURE__*/_react["default"].createElement("p", {
        className: baseClasses('error')
      }, t(deposit.error)), useTemplateDepositWorkflow && /*#__PURE__*/_react["default"].createElement("form", {
        className: slidePaneClasses('body'),
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-body')
      }, showTemplateTypeSelect && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, t('Select an option to continue the deposit process')), /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "TemplateType",
        customClass: baseClasses(),
        label: t('Options for deposit'),
        onSelect: function onSelect(value) {
          return selectDepositTemplate(product.ProductId, value);
        },
        options: templateTypes
      })), !deposit.depositInfo.length && /*#__PURE__*/_react["default"].createElement(_DepositTemplateFormComponent["default"], {
        product: product,
        template: deposit.template,
        submitting: submitting,
        baseClasses: baseClasses
      })))));
    }
  }]);
}(_react["default"].Component);
DepositFormComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    depositInfo: {},
    depositStatus: {}
  }
};
DepositFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  selectDepositProduct: _propTypes["default"].func.isRequired,
  showSnack: _propTypes["default"].func,
  deposit: _propTypes["default"].shape({
    templateInfo: _propTypes["default"].object.isRequired,
    template: _propTypes["default"].object.isRequired,
    isLoading: _propTypes["default"].bool.isRequired,
    error: _propTypes["default"].string,
    product: _propTypes["default"].number,
    depositInfo: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]).isRequired,
    depositStatus: _propTypes["default"].shape({
      success: _propTypes["default"].bool,
      RequestCode: _propTypes["default"].string
    }).isRequired
  })
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('core')(DepositFormComponent);